var map = {
	"./GitHub-Copilot.jpg": 36841,
	"./HEX_corto.avif": 15688,
	"./article-25-thumbnail.webp": 84766,
	"./article-25.webp": 67700,
	"./article-26-thumbnail.webp": 8,
	"./article-26.webp": 61821,
	"./article-27-thumbnail.webp": 73375,
	"./article-27.webp": 60600,
	"./article-28-thumbnail.webp": 39991,
	"./article-28.webp": 27224,
	"./article-29-thumbnail.webp": 37463,
	"./article-29.webp": 44651,
	"./article-30-thumbnail.webp": 98725,
	"./article-30.webp": 89227,
	"./articles-header.webp": 48417,
	"./average-conversion-ratio.avif": 25127,
	"./average-grades-increase.jpg": 8806,
	"./aws.avif": 44586,
	"./clinical-data.avif": 81289,
	"./comparative.avif": 77999,
	"./cough.avif": 86729,
	"./coversion-rate.avif": 79990,
	"./open-thread.avif": 71019,
	"./productivity-increases-ai.jpg": 86241,
	"./time-taken-decreases.jpg": 77377,
	"./tiny-chef.avif": 28550,
	"./transcript.avif": 62581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83005;